import React, {useState} from 'react';

import styles from './DeliveryCourier.module.css'
import {Radio} from "../../../../../../ui/Filters/components/Radio/Radio.tsx";
import {Order} from "../../../../../../types/Order.interface.ts";
import {DeliveryCourierAddress} from "./components/DeliveryCourierAddress/DeliveryCourierAddress.tsx";

interface Props {
    offer: Order,
}

export const DeliveryCourier: React.FC<Props> = ({offer }) => {
    const scheduleOptions = offer.delivery.time.map(({from, to}) => {
            const value = `C ${from} до ${to}`;

            return {
                label: value,
                value
            };
    });

    const [schedule, setSchedule] = useState<string>(scheduleOptions.length ? scheduleOptions[0].value : '')
    const isFreeDelivery = offer.delivery.price === 0;

    return (
        <>
            <div className={styles.address}>
                <DeliveryCourierAddress offer={offer} />
                <div className={styles.addressPrice}>
                    {isFreeDelivery ? 'Бесплатная доставка' : `Доставка ${offer.delivery.courierPrice} ₽`}
                </div>
            </div>
            {
                scheduleOptions.length
                ? <div className={styles.time}>
                    <div className={styles.timeLabel}>
                        Время доставки
                    </div>
                    <Radio
                        options={scheduleOptions}
                        selectedValue={schedule}
                        onChange={(option) => {
                            setSchedule(option)
                        }}
                    />
                </div>
                : null
            }
        </>
    );
};